const commaSeparator = (price:string) => {
    let str = price.split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str.join(".");
}

export default commaSeparator;